import { JobStatusEffects } from './job-status.effects';

export const effects: any[] = [JobStatusEffects];

export * from './job-status.effects';
